module.exports = __webpack_public_path__ + "img/task_tips2.b5a23407.png";